import { JSX } from 'react';
import { SxProps, Theme } from '@mui/material';
import { theme } from '../../configs/theme';
import { RowBox } from '../../styles/commonStyles';
import { InfoBoxSection } from './InfoBoxSection';
import ThemeButton from './ThemeButton';
import BorderColorIcon from '@mui/icons-material/BorderColor';

type Props = {
  sections: {
    title: string;
    items: { label: string; value: string | JSX.Element | null | undefined }[];
    sx?: SxProps<Theme>;
  }[];
  onClick?: React.MouseEventHandler;
};

export const SummaryBoard = ({ sections, onClick }: Props) => {
  return (
    <RowBox
      sx={{
        justifyContent: 'space-between',
        gap: '2rem',
        width: '100%',
        backgroundColor: theme.palette.common.white,
        borderRadius: '8px',
        padding: '1rem',
      }}
    >
      <RowBox
        sx={{
          gap: '2rem',
          flexWrap: 'wrap',
        }}
      >
        {sections.map((section, index) => (
          <InfoBoxSection
            key={`${section.title}-${index}`}
            title={section.title}
            items={section.items}
            showDividers={index < sections.length - 1}
            sx={section.sx}
          />
        ))}
      </RowBox>

      {onClick && (
        <ThemeButton data-testid="summary-board-edit-button" onClick={onClick}>
          <BorderColorIcon />
        </ThemeButton>
      )}
    </RowBox>
  );
};
